export default __webpack_public_path__ + "media/images/arrow-be441209fffa10c596415979a05976a3.svg";